import React from 'react'
import { SearchIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyMedia,
} from '@/shared/components/ui/empty'
import { cn } from '@/shared/lib/utils'

export default function WidgetEmptyState({
	size = 'medium',
}: {
	size?: 'small' | 'medium'
}) {
	const { t } = useTranslation()

	return (
		<Empty
			className={cn('h-full', {
				'gap-0 p-0 md:p-0': size === 'small',
			})}
		>
			<EmptyMedia variant='icon'>
				<SearchIcon className='text-muted-foreground' />
			</EmptyMedia>
			<EmptyDescription>
				{t('dashboard.empty_widget', { defaultValue: 'No data found to load' })}
			</EmptyDescription>
		</Empty>
	)
}
